/** internal utility to transform (for example) `"images"` into `"Images"`, the format needed for backend filtering in the media library */
export const uppercaseFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
